// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","fadein":"Home_fadein__RLnXq","text-container":"Home_text-container__o+JcS"};